import { createStorefrontApiClient } from '@shopify/storefront-api-client';

/**
 * Set up a new version of the Shopify Buy this uses the
 * token values set by {{ shopify:tokens }} in your template.
 */
const hasShopifyConfig = Boolean(window.shopifyConfig?.url && window.shopifyConfig?.token);

const client = hasShopifyConfig
    ? createStorefrontApiClient({
        storeDomain: window.shopifyConfig.url,
        apiVersion: window.shopifyConfig.apiVersion ?? '2025-04',
        publicAccessToken: window.shopifyConfig.token,
    })
    : {
        request: async () => ({
            data: null,
            errors: [{ message: 'Shopify storefront is not configured.' }],
        }),
    };

export default client;
